import React, { Component } from 'react';

import { Column, Table, AutoSizer } from 'react-virtualized';

class DispatchModalList extends Component {
  state = {
    filter: 'name',
    sameFilter: false,
    search: '',
  };

  findInSelected = item => {
    const { selected } = this.props;

    return (
      selected.findIndex(selectedItemID => selectedItemID === item.id) > -1
    );
  };

  findInHighlighted = item => {
    const { highlighted = [] } = this.props;

    return (
      highlighted.findIndex(selectedItemID => selectedItemID === item.id) > -1
    );
  };

  sortData = data => {
    const { filter, sameFilter } = this.state;
    let newData = data;
    if (filter) {
      newData = data.sort((a, b) => {
        if (typeof a[filter] === 'number' && typeof b[filter] === 'number') {
          return a[filter] - b[filter];
        } else if (
          typeof a[filter] == 'string' &&
          typeof b[filter] == 'string'
        ) {
          let lowerA = a[filter].toLowerCase();
          let lowerB = b[filter].toLowerCase();

          if (lowerA < lowerB) {
            return -1;
          }
          if (lowerA > lowerB) {
            return 1;
          }
          return 0;
        } else {
          return 1;
        }
      });
    }
    if (sameFilter) {
      return newData.reverse();
    } else {
      return newData;
    }
  };

  searchAndFilterData = () => {
    const { search } = this.state;
    let { data, columns } = this.props;

    if (!data || !data.length) {
      return [];
    }

    let result = data[0].hasOwnProperty('available')
      ? data.filter(_data => _data.available)
      : data;
    result = data[0].hasOwnProperty('deleted')
      ? data.filter(_data => !_data.deleted)
      : result;

    let filteredData = result;
    if (search !== '') {
      filteredData = filteredData.filter(item => {
        let included = false;
        for (let i = 0; i < columns.length; i++) {
          let key = columns[i].selector;
          let value = item[key];
          if (value && columns[i].type !== 'string') {
            value = value.toString();
          }
          if (value && value.toLowerCase().includes(search.toLowerCase())) {
            included = true;
            break;
          }
        }
        return included;
      });
    }
    return this.sortData(filteredData);
  };

  handleSearchChange = e => {
    this.setState({ search: e.target.value });
  };

  handleFilterClick = key => {
    const { filter, sameFilter } = this.state;

    if (filter === key && sameFilter === false) {
      this.setState({ sameFilter: true });
    } else {
      this.setState({ filter: key, sameFilter: false });
    }
  };

  getTableHeaderClassName = selector => {
    const { filter, sameFilter } = this.state;
    let className = 'table-header';
    if (selector === filter) {
      className = 'table-header active-asc';
      if (sameFilter) {
        className = 'table-header active-desc';
      }
    }
    return className;
  };

  cellRenderer = ({ cellData }) => {
    if (cellData == null) {
      return '';
    } else {
      return (
        <div className={this.findInSelected(cellData) ? 'highlight_row' : ''}>
          {String(cellData)}
        </div>
      );
    }
  };

  getRowStyle = index => {
    const { filteredData } = this;
    if (index > -1) {
      if (this.findInHighlighted(filteredData[index])) {
        return { background: '#e74c3c', color: 'white' };
        // return "red"
      } else if (this.findInSelected(filteredData[index])) {
        return { background: '#00ceb4', color: 'white' };
        // return 'blue';
      }
    }
    return {};
  };

  headerRenderer = ({ dataKey, label }) => {
    return <div className={this.getTableHeaderClassName(dataKey)}>{label}</div>;
  };

  getWidth = column => {
    if (
      column.title === 'Coffres' ||
      column.title === 'Contremaîtres' ||
      column.title === 'Camions' ||
      column.title === 'Ouvriers'
    ) {
      return 400;
    } else if (
      column.selector === 'description' ||
      column.selector === 'city' ||
      column.title === 'Client'
    ) {
      return 200;
    } else if (
      column.title === 'Ress.' ||
      column.selector === 'sequence' ||
      column.title === 'Étape'
    ) {
      return 50;
    } else if (column.title === 'Projet') {
      return 75;
    } else {
      return 100;
    }
  };

  render() {
    const { columns, onClick, data } = this.props;
    this.filteredData = this.searchAndFilterData();

    return (
      <div className="dispatch-modal-list">
        <label>
          Rechercher :
          <input
            type="search"
            className="search"
            onChange={e => this.handleSearchChange(e)}
          />
        </label>
        <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              width={width}
              height={window.innerHeight * 0.7}
              headerHeight={40}
              rowHeight={50}
              rowCount={this.filteredData.length}
              rowGetter={({ index }) => this.filteredData[index] || []}
              onRowClick={item => onClick(item.rowData)}
              rowStyle={({ index }) => this.getRowStyle(index)}
              sort={data => this.handleFilterClick(data.sortBy)}
            >
              {columns.map((column, index) => (
                <Column
                  label={column.title}
                  key={column.title}
                  dataKey={column.selector}
                  width={this.getWidth(column)}
                  cellRenderer={this.cellRenderer}
                  headerRenderer={this.headerRenderer}
                />
              ))}
              <Column
                label="Choisir"
                dataKey="id"
                width={40}
                cellRenderer={cellData => (
                  <input
                    type="checkbox"
                    readOnly
                    checked={this.findInSelected(cellData.rowData)}
                  />
                )}
              />
            </Table>
          )}
        </AutoSizer>
        <div>
          {`Affichage de ${this.filteredData.length} éléments (filtré de ${
            data.length
          } éléments au total)`}
        </div>
      </div>
    );
  }
}

DispatchModalList.propTypes = {};

export default DispatchModalList;
